import { render, staticRenderFns } from "./VDialogBtn.vue?vue&type=template&id=32d95ff4"
import script from "./VDialogBtn.vue?vue&type=script&lang=js"
export * from "./VDialogBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports